import React from "react";

export default class GameWindowBg extends React.Component{

    render(){
        const width = 80;
        const height = 115;
        let mainStyle = {
            position: "relative",
            background: this.props.color ?? "white",
            borderRadius: "3px",
            width: `${this.props.width ?? width}px`,
            height:`${this.props.height ?? height}px`
        }
        return <div style={mainStyle} onClick={this.props.onClick}>
            {this.props.value}
        </div>
    }

}